import {useCallback, useState} from "react";

export const useDisclosure = (initialState = false) => {
  const [isOpen, setOpen] = useState(initialState);

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const toggleOpen = useCallback(() => {
    setOpen((isOpen) => !isOpen);
  }, []);

  return {isOpen, onClose, onOpen, toggleOpen};
};
